import { render, staticRenderFns } from "./mybaojia.vue?vue&type=template&id=1da2d106&scoped=true&"
import script from "./mybaojia.vue?vue&type=script&lang=js&"
export * from "./mybaojia.vue?vue&type=script&lang=js&"
import style0 from "./mybaojia.vue?vue&type=style&index=0&id=1da2d106&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da2d106",
  null
  
)

export default component.exports